import { NgModule } from '@angular/core';

import { SkeletonTextComponent } from './skeleton-text.component';

@NgModule({
  declarations: [SkeletonTextComponent],
  exports: [SkeletonTextComponent]
})
export class SkeletonTextModule {}
